import { put, takeEvery } from 'redux-saga/effects';
import { createAction } from 'typesafe-actions';
import { SELECT_COLOR_BUTTON_IS_CLICKED } from 'features/product-info/ducks/product-tint-service';

/**
 * Событие должно срабатывать при клике на кнопку Выбрать цвет
 *
 * @see https://tracker.yandex.ru/PCP-10342
 */
export const gaClickSelectColorButton = createAction('GA:clickButton')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'outstoreServices';
  elementText: 'Выбрать цвет';
}>();

function* putGaClickSelectColorButton() {
  yield put(
    gaClickSelectColorButton({
      elementType: 'button',
      elementBlock: 'productDetail', // блок, в котором расположен элемент
      elementName: 'outstoreServices',
      elementText: 'Выбрать цвет',
    }),
  );
}

export function* runGaClickSelectColorButtonDetector() {
  yield takeEvery(SELECT_COLOR_BUTTON_IS_CLICKED, () => putGaClickSelectColorButton());
}
